// Smart-TV / 10-foot-UI detection from the user agent. Covers the major TV
// browser engines, including the LG webOS "Web0S" (zero) spelling and "LG
// Browser" that the plain "webos" check misses, plus Samsung Tizen, Android/
// Google TV, HbbTV set-tops and common brand tokens. Kept as a pure function so
// both the React hook and the pre-render bootstrap (Main.tsx) share one source.
// Specific tokens only — a bare 'tv' substring over-matches regular phone/desktop
// UAs and, now that a match triggers a 1.5x+ global zoom, a false positive is very
// visible. Samsung Tizen ("SMART-TV; ... Tizen") and LG webOS ("Web0S; ... SmartTV")
// — the tested devices — are both covered by these explicit markers.
const TV_UA_MARKERS = [
    'smart-tv',
    'smarttv',
    'smart_tv',
    'googletv',
    'android tv',
    'androidtv',
    'appletv',
    'tvos',
    'tizen', // Samsung
    'webos',
    'web0s',
    'lg browser',
    'netcast', // LG (older)
    'hbbtv',
    'ce-html',
    'nettv',
    'roku',
    'vidaa',
    'bravia',
    'aquos',
    'philipstv',
    'crkey', // Chromecast
];

export const isTvUserAgent = (
    ua: string = typeof navigator === 'undefined' ? '' : navigator.userAgent,
): boolean => {
    const lower = ua.toLowerCase();
    return TV_UA_MARKERS.some((marker) => lower.includes(marker));
};
